import Form from "react-bootstrap/Form";
import UserPicker from "../../controls/UserPicker";
import { ITipo_Campo } from "../../helpers/IFormHelper";

import { makeStyles, shorthands } from "@fluentui/react-components";

import Select from "react-select";
interface IRenderForm {
  tipoCampo: ITipo_Campo;
  texto: string;
  valor: any;
  callback: any;
  items?: any;
  id: any;
  readonly?: boolean;
  options?: Array<any>;
  callbackColumn?: (id: string, value: any) => void;
  required?: boolean;
  errorEmpty?: boolean;
}

const useStyles = makeStyles({
  root: {
    display: "grid",
  },
  select: {
    ...shorthands.border("1px", "solid"),
  },
});

const RenderForm = ({ tipoCampo, texto, valor, callback, items, id, readonly, options, required, errorEmpty, callbackColumn }: IRenderForm) => {//NO SONAR Dejamos justificado que necesitamos un switch con mas de 30 opciones ya que este método permite generar las columas de las listas mantenedoras, y el sistema el SGITOOLS tiene mas de 30 listas mantenedoras
  const styles = useStyles();

  let value = <div></div>;
  switch (tipoCampo) {
    case ITipo_Campo.text:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <Form.Control
            key={id}
            disabled={readonly}
            data-testid="test1"
            onChange={(e) => {
              callback(id, e.currentTarget.value, tipoCampo);
            }}
            name={id}
            title={texto}
            defaultValue={valor}
            className={errorEmpty ? "error" : ""}
          />
        </div>
      );
      break;
    case ITipo_Campo.multiline:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <Form.Control
            key={id}
            data-testid="test2"
            onChange={(e) => {
              callback(id, e.currentTarget.value, tipoCampo);
            }}
            name={id}
            title={texto}
            defaultValue={valor}
            as="textarea"
            rows={3}
            className={errorEmpty ? "error" : ""}
          />
        </div>
      );
      break;
    case ITipo_Campo.check:
      value = (
        <Form.Check
          onChange={(e) => {
            callback(id, e.target.checked, tipoCampo);
          }}
          key="1"
          name={id}
          type={"checkbox"}
          id={`default-${"checkbox"}`}
          label={texto}
          defaultChecked={valor}
        />
      );
      break;
    case ITipo_Campo.combo:
      let valueIT =
        items !== undefined && items.value !== undefined
          ? items.value.filter((it: any) => {
              return isNaN(valor) ? it.text === valor : it.value === valor;
            })
          : [];

      if (valueIT.length > 0 && callbackColumn) {
        callbackColumn(id, valueIT[0].value);
      }
      value = (
        <div className={styles.root}>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <Select
            placeholder="Seleccione"
            className={`${errorEmpty ? "error" : ""}`}
            isClearable={true}
            noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
            options={
              items !== undefined
                ? items.value.map((i: any) => {
                    return { value: i.value, label: i.text };
                  })
                : []
            }
            key={valueIT.length > 0 ? valueIT[0].value : ""}
            onChange={async (e: any) => {
              callback(id, e?.value?.toString(), tipoCampo);
              if (callbackColumn) {
                callbackColumn(id, e?.value);
              }
            }}
            defaultValue={valueIT.length > 0 ? { value: valueIT[0].value, label: valueIT[0].text } : ""}
          />
        </div>
      );
      break;
    case ITipo_Campo.key:
      value = (
        <div>
          <Form.Control key={id} name={id} type={"hidden"} value={valor} />
        </div>
      );
      break;
    case ITipo_Campo.user:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <div className="altoPicker">
            <UserPicker
              name={id}
              callback={callback}
              id={id}
              key={"1"}
              multi={false}
              disabled={false}
              defaultValue={valor}
              className={errorEmpty ? "error" : ""}
            />
          </div>
        </div>
      );
      break;
    case ITipo_Campo.userexternal:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <div className="altoPicker">
            <UserPicker
              name={id}
              callback={callback}
              id={id}
              key={"1"}
              multi={false}
              disabled={false}
              defaultValue={valor}
              className={errorEmpty ? "error" : ""}
              internal={false}
            />
          </div>
        </div>
      );
      break;
    case ITipo_Campo.userinternal:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <div className="altoPicker">
            <UserPicker
              name={id}
              callback={callback}
              id={id}
              key={"1"}
              multi={false}
              disabled={false}
              defaultValue={valor}
              className={errorEmpty ? "error" : ""}
              internal={true}
            />
          </div>
        </div>
      );
      break;
    case ITipo_Campo.multiuser:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <div className="altoPicker">
            <UserPicker
              name={id}
              callback={callback}
              id={id}
              key={"1"}
              multi={true}
              disabled={false}
              defaultValue={valor}
              className={errorEmpty ? "error" : ""}
            />
          </div>
        </div>
      );
      break;
    case ITipo_Campo.date:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <Form.Control
            onChange={(e) => {
              callback(id, e.currentTarget.value, tipoCampo);
            }}
            key={id}
            type="date"
            name={id}
            title={texto}
            defaultValue={valor}
            className={errorEmpty ? "error" : ""}
          />
        </div>
      );
      break;
    case ITipo_Campo.hour:
      value = (
        <div>
          <label>
            {required && <span className="colorRojo">(*)</span>}
            {texto}
          </label>
          <Form.Control
            data-testid="test4"
            onChange={(e) => {
              callback(id, e.currentTarget.value, tipoCampo);
            }}
            key={id}
            type="text"
            name={id}
            title={texto}
            defaultValue={valor}
            className={errorEmpty ? "error" : ""}
          />
        </div>
      );
      break;
    case ITipo_Campo.multicheck:
      value = (
        <div className="mt-2">
          <label>
            <strong>{texto}</strong>
          </label>
          <div className="checkParametros">
            {options?.map((o, i) => {
              return (
                <Form.Check
                  label={o.TITULO}
                  type={"checkbox"}
                  id={o.ID}
                  key={id}
                  name={id}
                  onChange={(e) => {
                    callback(id, e.currentTarget.checked, tipoCampo, o.ID);
                  }}
                  defaultChecked={(valor as Array<any>)?.indexOf(o.ID) > -1}
                />
              );
            })}
          </div>
        </div>
      );
      break;
  }
  return value;
};

export default RenderForm;
